/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.__LT_ENDPOINT__ = "https://translate.astian.org/translate";
  }

  // Страховка для dev/SPA: если вдруг шрифты не попали в head (например, при горячей перезагрузке)
  if (typeof document !== "undefined") {
    const id = "fonts-jura-inter";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href =
        "https://fonts.googleapis.com/css2?family=Jura:wght@400;500;600;700&family=Inter:wght@400;500;600;700;800&display=swap";
      document.head.appendChild(link);
    }
  }
};
